
/* eslint-disable max-len */
export default () => (
  <svg id="Laag_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
    <ellipse cx="15.6" cy="33.77" rx="4.48" ry="2.4" opacity=".2" fill="currentColor" />
    <path d="M14.84,25.08c2.24-.35,4.65-.54,7.16-.54,11.72,0,21.23,4.13,21.23,9.23s-9.5,9.23-21.23,9.23S.77,38.87.77,33.77c0-3.37,4.15-6.32,10.36-7.93" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.25" />
    <ellipse cx="15.6" cy="33.77" rx="4.48" ry="2.4" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.25" />
    <circle cx="28.73" cy="33.13" r="3.04" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.25" />
    <line x1="11.13" y1="33.77" x2="11.13" y2="1" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.25" />
    <polygon points="11.13 1 27.94 6.94 11.13 12.89 11.13 1" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.25" />
    <polygon points="11.13 1 27.94 6.94 11.13 12.89 11.13 1" opacity=".2" fill="currentColor" />
  </svg>
);
